import lukePic from "@/public/images/artists/luke.png";
import { Artist } from "@/types/types";

export const luke = {
  id: "111",
  name: "Luke",
  image: lukePic,
  description: `This rock vocalist exhibits a voice capable of raspy and screaming singing styles. With a wide vocal range, he demonstrates proficiency in belting and sustaining notes for extended durations. This dynamic vocal ability allows for compelling performances across diverse rock genres.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fluke-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock", "Belting", "Gritty"],
      secondary: ["Screaming"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 53,
        high: 68,
      },
    },
  },
} as const satisfies Artist;
